import it from '../JsonLang/it.json'
export const lang = { ...it }